var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareToTheRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 510,
    viewBox: "0 0 560 510",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M529 257.684L215.316 801L-328 487.316L-14.3162 -56L529 257.684ZM372.017 299.747L27.7473 100.983L-171.017 445.253L173.253 644.017L372.017 299.747Z",
    fill: "#6020D4",
    stroke: "#6020D4",
    strokeWidth: 45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareToTheRight);
export default __webpack_public_path__ + "static/media/Square-to-the-right.a11e831bc04c6166336d82e8f9477393.svg";
export { ForwardRef as ReactComponent };